export function hideFeedbackWidget(
  aptWidgetContainer: HTMLDivElement | null,
  botTarget: HTMLDivElement,
) {
  // Even though toggleFeedbackWidget() checks for the presence of the
  // aptWidgetContainer, we still need to check for it here to ensure that
  // this method works properly outside of toggleFeedbackWidget().
  //
  if (aptWidgetContainer) {
    botTarget.click();
  }
}
